import React, { useState } from "react";

interface DocumentItemProps {
  doc: { document_name: string; content: string };
}

const DocumentItem: React.FC<DocumentItemProps> = ({ doc }) => {
  const [showContent, setShowContent] = useState(false);

  const toggle = () => setShowContent(!showContent);

  return (
    <li className="mb-2" style={{ position: "relative" }}>
      <span
        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
        onClick={toggle}
      >
        <i className="ri-file-2-line me-2 text-secondary" />
        <span className="text-primary text-decoration-underline">{doc.document_name}</span>
      </span>

      {showContent && (
        <div
          className="border rounded p-2 mt-1 bg-light shadow-sm"
          style={{
            position: "relative",
            maxWidth: "400px",
            whiteSpace: "pre-wrap",
            zIndex: 10,
          }}
        >
          {doc.content}
        </div>
      )}
    </li>
  );
};

export default DocumentItem;
